import React from 'react';

import { Link } from '@remix-run/react';

export default function Footer() {
  return (
    <footer className="mt-auto border-t bg-gray-50 pt-12 text-black">
      <div className="container mx-auto flex flex-col justify-between gap-12 md:flex-row md:gap-0">
        {/* Company Info */}
        <div className="flex min-w-[600px] flex-1 flex-col gap-4">
          <Link className="mb-2 flex flex-row items-center" to={'/'}>
            <img src="/images/best2bid-logo.svg" className="w-10 md:w-12" />
          </Link>
          <div>
            <p className="mb-2 text-xl">How Can We Help You? Contact Us NOW!</p>
            <p className="mb-1 text-sm">Best2bid Technology Sdn Bhd</p>
            <p className="mb-1 text-sm">Co. Reg. No. 201701028455 (1242621-P)</p>
            <p className="mb-1 text-sm">(Incorporated in Malaysia)</p>
            <p className="mb-1 text-sm">
              Email:{' '}
              <a href="mailto:admin@best2bid.com" className="underline">
                admin@best2bid.com
              </a>
            </p>
          </div>
        </div>
        {/* Categories */}
        <div className="min-w-[150px] flex-1">
          <div className="text-md mb-4 text-gray-500">CATEGORIES</div>
          <ul className="space-y-1 text-sm">
            <li>
              <Link to="/products?category=Art" className="hover:underline">
                Art
              </Link>
            </li>
            <li>
              <Link to="/products?category=Antiques" className="hover:underline">
                Antiques
              </Link>
            </li>
            <li>
              <Link to="/products?category=Jewellery" className="hover:underline">
                Jewellery
              </Link>
            </li>
            <li>
              <Link to="/products?category=Collectibles" className="hover:underline">
                Collectibles
              </Link>
            </li>
            <li>
              <Link to="/products?category=Coins" className="hover:underline">
                Coins
              </Link>
            </li>
            <li>
              <Link to="/products?category=Property" className="hover:underline">
                Property
              </Link>
            </li>
          </ul>
        </div>
        {/* Explore */}
        <div className="min-w-[150px] flex-1">
          <div className="text-md mb-4 text-gray-500">EXPLORE</div>
          <ul className="space-y-1 text-sm">
            <li>
              <Link to="/auctions" className="hover:underline">
                Auctions
              </Link>
            </li>
            <li>
              <Link to="/products" className="hover:underline">
                All Products
              </Link>
            </li>
            <li>
              <Link to="/categories" className="hover:underline">
                All Categories
              </Link>
            </li>
          </ul>
        </div>
        {/* Account */}
        <div className="min-w-[150px] flex-1">
          <div className="text-md mb-4 text-gray-500">ACCOUNT</div>
          <ul className="space-y-1 text-sm">
            <li>
              <Link to="/login" className="hover:underline">
                Login
              </Link>
            </li>
            <li>
              <Link to="/register" className="hover:underline">
                Register
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {/* Bottom Bar */}
      <div className="mt-12 w-full border-t" />
      <div className="container mx-auto my-4 mb-12 flex flex-col items-center justify-start gap-6 pt-4 text-sm text-gray-500 md:flex-row">
        <Link to="/privacy-policy" className="hover:underline">
          Privacy Policy
        </Link>
        <Link to="/terms-of-use" className="hover:underline">
          Terms of Use
        </Link>
        <Link to="/fulfillment-policy" className="hover:underline">
          Fulfillment Policy
        </Link>
      </div>
    </footer>
  );
}
